import React, { useMemo } from 'react';
import { SearchResponseEvents } from '../../../../utils/transformation';
import { LocationPickerContainer } from '../ExploratoryPageResultsContainer/LocationPickerContainer/LocationPickerContainer';
import { TopPicksCarousel } from '../ExploratoryPageResultsContainer/TopPicksCarousel/TopPicksCarousel';
import { FilterHeaderContainer } from '../FilterHeaderContainer';
import FilterPanelContainer from '../FilterPanelContainer';
import EventSuggestionsSection from './EventSuggestionsSection';
import MoreEventsSection from './MoreEventsSection';
import NoResultsMessage from './NoResultsMessage';
import PaginationControls from './PaginationControls';
import PromotedEventsSection from './PromotedEventsSection';
import { SearchHeaderContainer } from './SearchHeaderContainer';

import styles from './ExploratoryPageResultsContainer.module.scss';

interface ExploratoryPageResultsContainerProps extends SearchResponseEvents {
    isLoading: boolean;
    locale: string;
}

export const ExploratoryPageResultsContainer = ({
    events,
    pagination,
    isLoading,
    locale,
}: ExploratoryPageResultsContainerProps) => {
    const shouldRenderSuggestions = useMemo(() => {
        const isNextDisabled = pagination.page === pagination.pageCount;
        const hasEventResults = pagination.objectCount > 0;

        return !isLoading && (!hasEventResults || isNextDisabled);
    }, [pagination, isLoading]);

    return (
        <div className={styles.root}>
            <div className={styles.resultsSection}>
                <section className={styles.header}>
                    <SearchHeaderContainer />
                    <LocationPickerContainer />
                    <FilterHeaderContainer isExploratoryDSRP />
                    <FilterPanelContainer isExploratoryDSRP />
                </section>
                {shouldRenderSuggestions && <NoResultsMessage />}
                <PromotedEventsSection
                    promotedEvents={events.promoted}
                    isLoading={isLoading}
                />
                {shouldRenderSuggestions && <EventSuggestionsSection />}
                <TopPicksCarousel
                    carouselEvents={events.organic}
                    locale={locale}
                    isLoading={isLoading}
                    pagination={pagination}
                />
                <MoreEventsSection
                    events={events.organic}
                    isLoading={isLoading}
                />
                <PaginationControls pagination={pagination} />
            </div>
        </div>
    );
};
